import React, { useEffect, useState } from "react";
// import { useChat } from "../context/ChatProvider";
import { useChat } from "../../context/provider/ChatProvider";
import { AuthFetchTGUIO} from "../../services/api";
import { notify } from "../../utils/utils";



const useMessages = () => {
    const { socket, currentRoom } = useChat();
    const [messages, setMessages] = useState([]);
    
    
    
    const listarMensajes = async (sala) =>{
        console.log("SALA DE LISTAR MENSJES -> " , sala)
        // const response = await Fetch({url:`https://chatws-dev.abexa.pe/api/rooms/${sala.id}/messages`})
        const response = await AuthFetchTGUIO(`/chat-groups/${sala.id}/messages`)
        
        if (response.isValid){
            console.log("LISTA de mensajes  ->", response.content)

            setMessages(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        } 
    }   
    
    useEffect(() => {
        socket.on('message-received', (data) => {
            console.log("MENSAJE RECIBIDO")
            setMessages((m) => [...m, data]);
        });

        return () => {
            socket.off('message-received');
        }
    }, [socket]);

    useEffect(() => {
        setMessages([]);
        listarMensajes(currentRoom)
    }, [currentRoom])

    return messages;
}

export default useMessages;
